module.exports = {
	"auctionStatus": {
		"canFinalize": "Tous les lots ont été vendus ou annulés, vous devez toutefois encore finaliser l'encan. Vous pouvez finaliser l'encan dans le panneau à votre droite."
	},
	"auctionStatusPanel": {
		"header": "Statut de l'encan",
		"status": {
			"cancelled": {
				"description": "L'encan a été annulé.",
				"title": "Annulé"
			},
			"finished": {
				"description": "L'encan est terminé. Vous pouvez vous diriger vers le compte-rendu en utilisant le lien ci-dessous.",
				"title": "Terminé"
			},
			"ongoing": {
				"description": "L'encan est en cours. Les utilisateurs peuvent effectuer des enchères.",
				"title": "En cours"
			},
			"paused": {
				"description": "L'encan est en pause. Les utilisateurs ont été avisés qu'ils pourront à nouveau effectuer des enchères lorsque l'encan redébutera.",
				"title": "En pause"
			},
			"pendingFinalization": {
				"description": "L'encan est en cours, mais tous les lots ont été vendus ou annulés. Vous pouvez maintenant finaliser l'encan pour générer le compte-rendu.",
				"title": "En attente de finalisation"
			},
			"waiting": {
				"description": "L'encan n'a pas encore débuté. Les utilisateurs sont invités à attendre.",
				"title": "En attente"
			}
		},
		"action": {
			"cancel": {
				"option": "Annuler l'encan",
				"header": "Annulation",
				"confirmation": "Êtes-vous sûr de vouloir annuler l'encan? Les lots déjà vendus le demeureront, les autres seront annulés.",
				"yesButton": "Oui, annuler.",
				"noButton": "Non, continuer."
			},
			"finalize": "Finaliser l'encan",
			"goToReport": "Consulter le compte-rendu",
			"pause": "Mettre l'encan en pause",
			"resume": "Revenir de la pause",
			"start": "Débuter l'encan"
		}
	},
	"controlsPanel": {
		"messagePlaceholder": "Entrez un message à transmettre dans l'encan ici...",
		"sendButton": "Envoyer",
		"replaceBidButton": {
			"text": "Remplacer enchère pour enchère sur place"
		},
		"undoBidButton": {
			"text": "Annuler dernière enchère temps réel",
			"title": "Le lot actuel doit être en cours ou fermé afin de pouvoir annuler la dernière enchère effectuée en temps réel."
		}
	},
	"lotAction": {
		"cancel": "Annuler le lot",
		"jump": "Aller au prochain lot disponible",
		"lastCall": "Débuter la dernière chance",
		"open": "Ouvrir le lot aux enchères",
		"reopen": "Réouvrir le lot aux enchères",
		"sell": "Vendre le lot",
		"skip": "Sauter le lot et aller au suivant"
	},
	"lotCatalog": {
		"action": {
			"cancel": "$t(cancel)",
			"jump": "Sauter à ce lot"
		},
		"noLotFound": "Aucun lot trouvé."
	},
	"module": {
		"controls": "Contrôles"
	},
	"reserve": "Réserve"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/widget-admin.json5
// module id = 2015
// module chunks = 6